import { NudgeTrackingSlice } from './nudge-tracking-types'

export const makeNudgeTrackingInitialState = (): NudgeTrackingSlice => {
  return {
    recurringNudge: {
      wasShown: false,
      wasAccepted: null,
    },
    dcfNudge: {
      wasShown: false,
      wasAccepted: null,
    },
  }
}
